import { trackBuilderEvent } from "../../helpers/builderAnalytics";

export function trackPodcastAction(action, { builderId, runId, source }) {
  if (!builderId || !runId) return;
  trackBuilderEvent(`builder_podcast_${action}`, {
    builder_id: builderId,
    run_id: runId,
    source,
  });
}
